import { create, FedopsLogger } from '@wix/fedops-logger';

let logger: FedopsLogger | undefined;

export enum LoadingPhase {
  Bootstrap = 'Bootstrap',
  Paint = 'Paint',
  ReceivedSettingsAndStyles = 'ReceivedSettingsAndStyles',
  ReceivedCurrentMemberDetails = 'ReceivedCurrentMemberDetails',
}

const init = ({ appName }: { appName: string }) => {
  logger = create ? create(appName) : undefined;
};

const appLoadingPhaseStart = (phaseName: LoadingPhase) =>
  logger && logger.appLoadingPhaseStart(phaseName);

const appLoaded = () => logger && logger.appLoaded();

const interactionStarted = (interaction: string) =>
  logger && logger.interactionStarted(interaction);
const interactionEnded = (interaction: string) =>
  logger && logger.interactionEnded(interaction);

export const fedopsLogger = {
  init,
  appLoadingPhaseStart,
  appLoaded,
  interactionStarted,
  interactionEnded,
};
